import { render, staticRenderFns } from "./submissionPanel.vue?vue&type=template&id=e5013594&scoped=true&"
import script from "./submissionPanel.vue?vue&type=script&lang=ts&"
export * from "./submissionPanel.vue?vue&type=script&lang=ts&"
import style0 from "./submissionPanel.vue?vue&type=style&index=0&id=e5013594&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5013594",
  null
  
)

export default component.exports